import { defineStore } from "pinia";
import { computed, ref } from "vue";
import { FLAP_VAULTS } from "@/data/vaults.js";
import { api } from "@/api/client.js";
import { flapUrl } from "@/lib/ui.js";

export const useVaultsStore = defineStore("vaults", () => {
  const list = ref(FLAP_VAULTS);
  const query = ref("");
  const category = ref("");
  const showcaseByFactory = ref({});
  const showcaseLoaded = ref(false);

  function enrichVault(v) {
    const factory = String(v.factory || "").toLowerCase();
    const hit = showcaseByFactory.value[factory];
    if (!hit?.token) return v;
    const sym = String(hit.symbol || "").trim();
    const name = String(hit.name || "").trim();
    const img = String(hit.image || "").trim();
    return {
      ...v,
      tokenCA: hit.token,
      tokenSymbol: sym || v.tokenSymbol,
      tokenName: name || v.tokenName,
      image: img || v.image,
      flapUrl: flapUrl(hit.token),
      showcaseMcap: hit.mcap,
      showcaseListed: hit.listed,
    };
  }

  const displayList = computed(() => list.value.map(enrichVault));

  const filtered = computed(() => {
    const q = query.value.trim().toLowerCase();
    return displayList.value.filter((v) => {
      if (category.value && v.category !== category.value) return false;
      if (!q) return true;
      const hay = [
        v.name,
        v.nameEn,
        v.summary,
        v.summaryEn,
        v.tokenSymbol,
        v.factory,
        ...(v.tags || []),
      ]
        .join(" ")
        .toLowerCase();
      return hay.includes(q);
    });
  });

  const news = computed(() => displayList.value.filter((v) => v.isNew));
  const stockVaults = computed(() =>
    displayList.value.filter((v) => v.category === "stock")
  );
  const flexVaults = computed(() =>
    displayList.value.filter((v) => v.category === "flex")
  );

  async function loadShowcase() {
    try {
      const data = await api.factoryShowcase();
      if (data?.map && typeof data.map === "object") {
        showcaseByFactory.value = data.map;
      }
    } catch {
      /* 保留 vaults.js 静态展示币 */
    }
    showcaseLoaded.value = true;
  }

  return {
    list,
    displayList,
    query,
    category,
    filtered,
    news,
    stockVaults,
    flexVaults,
    showcaseByFactory,
    showcaseLoaded,
    loadShowcase,
    enrichVault,
  };
});
